/**
 * @desc 保存或修改
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.paymentMaster.save.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentMaster/save`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
